import { render, staticRenderFns } from "./BranchtoTreasury.vue?vue&type=template&id=e91d7a8a&scoped=true"
import script from "./BranchtoTreasury.vue?vue&type=script&lang=js"
export * from "./BranchtoTreasury.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91d7a8a",
  null
  
)

export default component.exports